import React from 'react';
import { Container } from 'reactstrap';
import CustomerStatesView from '../../features/customer-states/components/CustomerStatesView';

const CustomerStatesPage = () => {
    document.title = "Estados de Clientes | Tren Taita Imbabura";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <CustomerStatesView />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default CustomerStatesPage;
